/**
 * Multiselect editor — v1 renders a comma-separated text input (e.g. email
 * recipients, calendar attendees). The value round-trips as a string[]. A
 * chip/typeahead editor is an additive follow-up when a connector needs it.
 */
import type { ProposalFieldEditorProps } from "../ProposalEditor.js";
import { controlStyle, fieldDomId } from "../ProposalEditor.js";

function toText(value: unknown): string {
  if (Array.isArray(value)) return value.map((v) => String(v)).join(", ");
  return value == null ? "" : String(value);
}

function toArray(text: string): string[] {
  return text
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}

export function MultiselectField({ field, value, onChange, idPrefix }: ProposalFieldEditorProps) {
  return (
    <input
      id={fieldDomId(idPrefix, field.key)}
      type="text"
      aria-label={field.label}
      placeholder="Comma-separated"
      style={controlStyle}
      defaultValue={toText(value)}
      onChange={(e) => onChange(toArray(e.target.value))}
    />
  );
}
